import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { TerminosComponent } from './componentes/terminos/terminos.component';
import { AvisoDePrivacidadComponent } from './componentes/aviso-de-privacidad/aviso-de-privacidad.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'terminos-y-condiciones',
    component: TerminosComponent,
  },
  {
    path: 'aviso-de-privacidad',
    component: AvisoDePrivacidadComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingRoutingModule {}
